import { findAll, register } from '../../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentprefix
  const menuLinks = findAll(`.${componentPrefix}submenuToggle`)
  const menuAnchors = findAll(`.${componentPrefix}anchor`)
  const mobileMenuBtn = document.getElementById('mobileMenuBtn')

  menuLinks.forEach(element => {
    element.addEventListener('click', function (e) {
      element.closest('li').classList.toggle(`${componentPrefix}-open`)
      e.preventDefault()
    })
  })

  menuAnchors.forEach(element => {
    element.addEventListener('click', function (e) {
      document.body.classList.toggle('nav-open')
    })
  })

  mobileMenuBtn.addEventListener('click', () => {
    document.body.classList.toggle('nav-open')
  })
}

register('mobileNav', component)
